import { defineStore } from 'pinia'

const useSelectedFilterStore = defineStore('selectedFilter', {
  state(){return{
    selectedFilters: []
  }},
  getters: {
    getAllSelectedFilters: (state) => state.selectedFilters
  },
  actions: {
    addFilters(item) {
      this.selectedFilters.push(item)
    },
    deleteFilters(indexToRemove) {
      this.selectedFilters.splice(indexToRemove, 1);
    }
  }
})
export {useSelectedFilterStore}